<template>
    <div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15 width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
				placeholder="--"
                :col="1">
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15 width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1">
            </compFormEdit>
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history',{defaultValue:'操作历史'})" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="morelogcolumn"></compLog>
		</compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetSurChargeRuleOne, HttpSaveSurChargeRuleOne } from '@/service/account';
import { mapGetters } from 'vuex';
export default {
    props:['activeid','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeid,
            logList:[],
            formData:{},
            loading:false,
        }
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
	},
    created(){
        this.getDetail()
    },
    computed:{
        getBase(){
            return [
                {
                    label: this.$t('fbb.carrier.extra_rule_name',{defaultValue:'规则名称'}),
                    key: "ruleName",
                },
                {
                    label: this.$t('fbb.addonRule.ruleRangeFormula',{defaultValue:'规则公式'}),
                    key: "ruleRangeFormula",
                },
            ]
        },
    },
    methods:{
        getDetail(){
            if(this.type == 'add') return;
            this.loading = true;
            HttpGetSurChargeRuleOne({
                id:this.id,
            }).then(res=>{
                this.formData = res.data;
                this.logList = res.data.addRuleLogs;
                this.loading = false;
            },err=>{
                this.$VMessage.error(err.message);
                this.loading = false;
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            this.loading = true;
            HttpSaveSurChargeRuleOne({
                id:this.id,
                ruleName:this.formData.ruleName,
                ruleRangeFormula:this.formData.ruleRangeFormula,
            }).then(res=>{
                this.loading = false;
                this.$VMessage.success(res.message);
                this.cancel();
            },err=>{
                this.$VMessage.error(err.message);
                this.loading = false;
            })
        },
        cancel(){
            this.$router.push({ name: 'surchargeruleList' });
        }
    }
}
</script>
